import { View } from "react-native";
import TouchableWithoutFeedback from "src/components/TouchableWithoutFeedback";
import { Image } from "src/swsh-native";
import { CommentAttachmentType } from "../types";

const CommentLargeImageWidth = 180;
const CommentLargeImageHeight = 225;
const CommentLargeImageVerticalInset = 18;
const CommentLargeImagePadding = 6;
const CommentLargeImageRadius = 18;
const CommentAttachmentLargeImage = ({
	attachment,
}: {
	attachment: CommentAttachmentType.LargeImage;
}) => {
	return (
		<View
			style={{
				height: CommentLargeImageHeight - CommentLargeImageVerticalInset,
				width: CommentLargeImageWidth,
				opacity: 0.6,
			}}
		>
			<TouchableWithoutFeedback
				onPress={attachment.onPress}
				containerStyle={{
					position: "absolute",
					width: CommentLargeImageWidth,
					height: CommentLargeImageHeight,
					borderRadius: CommentLargeImageRadius,
					backgroundColor: "#FFFFFF",
				}}
				style={{
					padding: CommentLargeImagePadding,
				}}
			>
				<Image
					alt="Comment Image Thread"
					dim={{
						width: CommentLargeImageWidth - 2 * CommentLargeImagePadding,
						height: CommentLargeImageHeight - 2 * CommentLargeImagePadding,
					}}
					style={{
						borderRadius: CommentLargeImageRadius - CommentLargeImagePadding / 2,
					}}
					src={attachment.imageUrl}
				/>
			</TouchableWithoutFeedback>
		</View>
	);
};

export default CommentAttachmentLargeImage;
